import { PasteIcon, PenIcon } from "@/components/icons";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useState } from "react";
import { PricingAnchor } from "../../pricing-configurator.types";
import { PricingAnchorTable, PricingAnchorTableProps } from "./pricing-anchor-table";
import { PricingPasteTable } from "./pricing-paste-table";

type AnchorInputMode = "manual" | "paste";

type AnchorInputSectionProps = PricingAnchorTableProps & {
  onApplyAsAnchors?: (anchors: PricingAnchor[]) => void;
};

export const AnchorInputSection = ({ onApplyAsAnchors, ...props }: AnchorInputSectionProps) => {
  const [mode, setMode] = useState<AnchorInputMode>("manual");

  return (
    <div className="space-y-3">
      <div>
        <h3 className="text-sm font-medium">Points d'ancrage</h3>
        <p className="text-xs text-muted-foreground">Définissez votre structure tarifaire de base</p>
      </div>
      <Tabs value={mode} onValueChange={(value) => setMode(value as AnchorInputMode)}>
        <TabsList className="h-8">
          <TabsTrigger value="manual" className="gap-1.5 text-xs">
            <PenIcon className="h-3.5 w-3.5" />
            Saisie manuelle
          </TabsTrigger>
          <TabsTrigger value="paste" className="gap-1.5 text-xs">
            <PasteIcon className="h-3.5 w-3.5" />
            Coller un tableau
          </TabsTrigger>
        </TabsList>
      </Tabs>
      {mode === "manual" ? (
        <PricingAnchorTable {...props} />
      ) : (
        <PricingPasteTable
          onApply={
            onApplyAsAnchors &&
            ((anchors) => {
              onApplyAsAnchors(anchors);
              setMode("manual");
            })
          }
        />
      )}
    </div>
  );
};
